"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CashFlowReportResponseSchema = exports.CashFlowReportSchema = exports.PipelineReportResponseSchema = exports.PipelineReportSchema = exports.JobProfitabilityReportResponseSchema = exports.JobProfitabilityReportSchema = exports.QuoteConversionReportResponseSchema = exports.QuoteConversionReportSchema = exports.RevenueReportResponseSchema = exports.RevenueReportSchema = exports.RevenueReportQuery = exports.ReportingRangeQuery = exports.ReportingPeriodSchema = void 0;
const zod_1 = require("zod");
// All monetary values are integer cents. Percentages are 0-100 rounded to 1dp.
// Responses follow the atGlance convention: `data` is null when the caller
// lacks the permission gating that report; `updatedAt` reflects cache freshness.
exports.ReportingPeriodSchema = zod_1.z.enum(['daily', 'weekly', 'monthly']);
exports.ReportingRangeQuery = zod_1.z.object({
    from: zod_1.z.string().date().optional(),
    to: zod_1.z.string().date().optional(),
});
exports.RevenueReportQuery = exports.ReportingRangeQuery.extend({
    period: exports.ReportingPeriodSchema.default('daily'),
});
const nullableNumber = zod_1.z.union([zod_1.z.number(), zod_1.z.null()]);
const revenueBucket = zod_1.z.object({
    periodStart: zod_1.z.string(),
    invoiced: zod_1.z.number(),
    materialsCost: nullableNumber,
    grossProfit: nullableNumber,
    marginPct: nullableNumber,
});
exports.RevenueReportSchema = zod_1.z.object({
    period: exports.ReportingPeriodSchema,
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    buckets: zod_1.z.array(revenueBucket),
    totals: zod_1.z.object({
        invoiced: zod_1.z.number(),
        materialsCost: nullableNumber,
        grossProfit: nullableNumber,
        marginPct: nullableNumber,
    }),
    invoiceCount: zod_1.z.number(),
    costCoveragePct: zod_1.z.number(),
});
exports.RevenueReportResponseSchema = zod_1.z.object({
    data: zod_1.z.union([exports.RevenueReportSchema, zod_1.z.null()]),
    updatedAt: zod_1.z.string(),
});
exports.QuoteConversionReportSchema = zod_1.z.object({
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    sentCount: zod_1.z.number(),
    acceptedCount: zod_1.z.number(),
    rejectedCount: zod_1.z.number(),
    awaitingCount: zod_1.z.number(),
    conversionPct: nullableNumber,
    quotedValue: zod_1.z.number(),
    wonValue: zod_1.z.number(),
    valueConversionPct: nullableNumber,
});
exports.QuoteConversionReportResponseSchema = zod_1.z.object({
    data: zod_1.z.union([exports.QuoteConversionReportSchema, zod_1.z.null()]),
    updatedAt: zod_1.z.string(),
});
const jobProfitRow = zod_1.z.object({
    jobId: zod_1.z.string(),
    jobStatus: zod_1.z.string(),
    quoteId: zod_1.z.string(),
    quoteNumber: zod_1.z.number(),
    quoteName: zod_1.z.string(),
    customerName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    quotedPrice: zod_1.z.number(),
    materialsCost: zod_1.z.number(),
    grossProfit: zod_1.z.number(),
    marginPct: nullableNumber,
    hasVariation: zod_1.z.boolean(),
    lineItemCount: zod_1.z.number(),
    zeroCostItemCount: zod_1.z.number(),
});
exports.JobProfitabilityReportSchema = zod_1.z.object({
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    jobs: zod_1.z.array(jobProfitRow),
    totals: zod_1.z.object({
        quotedPrice: zod_1.z.number(),
        materialsCost: zod_1.z.number(),
        grossProfit: zod_1.z.number(),
        marginPct: nullableNumber,
    }),
});
exports.JobProfitabilityReportResponseSchema = zod_1.z.object({
    data: zod_1.z.union([exports.JobProfitabilityReportSchema, zod_1.z.null()]),
    updatedAt: zod_1.z.string(),
});
const stageSummary = zod_1.z.object({
    count: zod_1.z.number(),
    value: zod_1.z.number(),
});
exports.PipelineReportSchema = zod_1.z.object({
    draftQuotes: stageSummary,
    pendingQuotes: stageSummary,
    jobsByStage: zod_1.z.object({
        instant: stageSummary,
        toSchedule: stageSummary,
        scheduled: stageSummary,
        inProgress: stageSummary,
    }),
    doneLast30Days: stageSummary,
    totalPipelineValue: zod_1.z.number(),
});
exports.PipelineReportResponseSchema = zod_1.z.object({
    data: zod_1.z.union([exports.PipelineReportSchema, zod_1.z.null()]),
    updatedAt: zod_1.z.string(),
});
const countTotal = zod_1.z.object({
    count: zod_1.z.number(),
    total: zod_1.z.number(),
});
exports.CashFlowReportSchema = zod_1.z.object({
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    billed: zod_1.z.object({
        invoiced: countTotal,
        paid: countTotal,
        unpaid: countTotal,
    }),
    outstanding: countTotal,
    overdue: countTotal,
    aging: zod_1.z.object({
        current: countTotal,
        days1to30: countTotal,
        days31to60: countTotal,
        days60plus: countTotal,
    }),
    expected: zod_1.z.object({
        next7Days: countTotal,
        next30Days: countTotal,
    }),
    unsent: countTotal,
});
exports.CashFlowReportResponseSchema = zod_1.z.object({
    data: zod_1.z.union([exports.CashFlowReportSchema, zod_1.z.null()]),
    updatedAt: zod_1.z.string(),
});
